module.exports = __webpack_public_path__ + "bc5ad1b2a3fba75ee1e6bffb2dcbc94c.svg";